export { SaleIcon } from './sale'
